<template>
 <div>
 <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="invoice-create-page">
    <!--  credit form component -->
    <RefundPaymentForm 
    page="create" 
    :duplicatecode="duplicatecode"
    v-on:FormUpdate="FormUpdate = 1"
    :lists="lists" 
    :message="message"
    v-on:onSubmit="onSubmit($event)"
    :submitted="submitted">
      <!-- footer block -->
    </RefundPaymentForm>
  </div>
  </div>
</template>

<script>
import RefundPaymentForm from "@/components/Form/PaymentsReceived/RefundForm"; // payment form for update payment record
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling date in format
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "CreditRefund",
  mixins: [notificationMixin, formatDate], // call the glbal mixin fucntion
  components: {
    RefundPaymentForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      message: '',
      lists: "",
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.duplicatecode = false;
      this.message='';
      this.$store
        .dispatch("credit/updateRefund", {
          id: this.$route.params.id,
          field: data
        })
        .then((response) => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          if (response.data.code == 200||response.data.code==404) {
             //  code for notificatin display
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.status,
            type: response.data.type,
            showCloseButton: true
          });
            //  show if invoice successfully created
            this.$router.push({
              name: "CreditView",
              params:{id: this.$route.params.id},
            });
          } else {
            this.message=response.data.status
            this.duplicatecode = true;
            this.submitted = false;
          }
         
        })
        .catch(() => {});
    }
  },
  updated: function() {},
  created() {
    if (Object.entries(this.list).length == 0) {
      this.$router.go(-2);
      return;
    }
    this.lists = {
      cus_id: this.list.header_details.cus_name,
      is_export: this.list.header_details.is_export,
      cus_currency: this.list.header_details.cus_currency,
      unit_currency_value: this.list.header_details.unit_currency_value,
      pymnt_date: this.formatDate(new Date()),
      date: this.list.header_details.crdt_date,
      pymnt_mthd: "1",
      from_account: "",
      tns_no: "",
      due_amount: parseFloat(this.list.header_details.available_amount).toFixed(
        2
      ),
      paid_amount: parseFloat(
        this.list.header_details.available_amount
      ).toFixed(2),
      list_no: "Credit Note" + this.list.header_details.crdt_no,
      disabled: false
    };

    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("general/fetchPaymentmethod").then(() => {
      next();
    });
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: state => state.credit.list,
      code: state => state.credit.code,
      status_code: state => state.credit.status_code, 
      status_message: state => state.credit.status_message, 
      status_type: state => state.credit.status_type
    })
  }
};
</script> 

<style>
</style>
